import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';
import { ProvidersV2 } from "./ProvidersV2";
import { DataProvider } from './context/DataContext'
import { Helmet } from 'react-helmet';

// Create a root for rendering the app
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Render the App component inside the root
root.render(
    <DataProvider>
      <Helmet>
        <meta name="description" content="European election poll data and statistics." />
      </Helmet>
      <ProvidersV2 />
    </DataProvider>
);
